var _circle, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBankOptionLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72.125,
    height: 71.562,
    viewBox: "0 0 72.125 71.562",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_27",
    "data-name": "Ellipse 27",
    cx: 2.862,
    cy: 2.862,
    r: 2.862,
    transform: "translate(33.16 12.564)",
    fill: "#66cd78"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M69.308,470H2.817a2.817,2.817,0,0,0,0,5.635h66.49a2.817,2.817,0,0,0,0-5.635Z",
    transform: "translate(0 -404.073)",
    fill: "#66cd78"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M72.125,19.608a2.817,2.817,0,0,0-1.674-2.575L37.135,2.242a2.817,2.817,0,0,0-2.291,0L1.67,17.035A2.818,2.818,0,0,0,0,19.608v7.466c0,.024,0,.047,0,.07s0,.047,0,.07a2.817,2.817,0,0,0,2.817,2.817c1.654,0,2.395,1.415,2.395,2.817V59.124c0,.059.005.117.009.175s-.009.116-.009.175A2.817,2.817,0,0,0,8.03,62.292H64.377a2.817,2.817,0,0,0,0-5.635H55.925V32.85a2.817,2.817,0,1,1,5.635,0V45.319a2.817,2.817,0,0,0,5.635,0V32.85c0-.661.152-2.817,2.113-2.817a2.817,2.817,0,0,0,2.817-2.817c0-.024,0-.047,0-.07s0-.047,0-.07ZM16.482,56.657H10.847V32.85a2.817,2.817,0,0,1,5.635,0Zm11.27,0H22.117V32.85a2.817,2.817,0,0,1,5.635,0Zm11.27,0H33.386V32.85a2.817,2.817,0,0,1,5.635,0Zm11.27,0H44.656V32.85a2.817,2.817,0,0,1,5.635,0Zm16.2-32.4H5.635v-2.82L35.995,7.9,66.49,21.44Z",
    transform: "translate(0 -1.999)",
    fill: "#66cd78"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankOptionLogo);
export default __webpack_public_path__ + "static/media/BankOptionLogo.410a88a3c4eb18fe4b41fd8a108df4af.svg";
export { ForwardRef as ReactComponent };